import { render, staticRenderFns } from "./ServicesAgreementWS.vue?vue&type=template&id=5529ad96&scoped=true"
import script from "./ServicesAgreementWS.vue?vue&type=script&lang=js"
export * from "./ServicesAgreementWS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529ad96",
  null
  
)

export default component.exports